<template>
  <div class="card-offer" :class="{ 'card-offer_active': status === 'active' }">
    <div class="card-offer__title">{{ title }}</div>
    <div class="card-offer__bottom">
      <el-button
        v-if="status === 'active'"
        size="small"
        type="success"
        plain
        disabled
        >Claimed</el-button
      >
      <el-button v-else size="small" type="info" plain disabled>Sent</el-button>
      <div class="card-offer__date">{{ formatDate(date) }}</div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";
defineProps({
  title: {
    type: String,
    default: null,
  },
  date: {
    type: String,
    default: null,
  },
  status: {
    type: String,
    default: null,
  },
});

const formatDate = (date) => {
  const dateNew = new Date(date);

  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
  };

  const formattedDate = dateNew.toLocaleString("en-US", options);
  return formattedDate;
};
</script>

<style lang="scss" scoped>
.card-offer {
  border-radius: var(--Radius-border-radius-base, 4px);
  background: var(--Color-Info-color-info-light-8, #e9e9eb);
  padding: 12px;
  &_active {
    background: var(--Color-Success-color-success-light-9, #f0f9eb);
    .card-offer__title {
      color: var(--Color-Success-color-success-dark-2, #529b2e);
    }
    .card-offer__date {
      color: var(--Color-Text-text-color-regular, #606266);
    }
  }
  &__title {
    color: var(--Color-Text-text-color-secondary, #909399);
    margin-bottom: 4px;
    font-size: 14px;
    font-weight: 800;
    line-height: 22px;
  }
  &__bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &__date {
    color: var(--Color-Text-text-color-secondary, #909399);
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
  }
}
</style>
